import api from "../../api";

export async function get(url) {
  try {
    const { data } = await api.get(url);
    return data;
  } catch (err) {
    console.log(err);
  }
}

export async function post(url, val) {
  try {
    const { data } = await api.post(url, val);
    return data;
  } catch (err) {
    console.log(err);
  }
}

export async function patch(url, data) {
  try {
    if (data?.title === "Featured News" && data?.additionalProp1?.no_of_items) {
      console.log("Featured News ", data);
      data.additionalProp1["no_of_items"] = data.no_of_items;
    }
    await api.patch(url, data);
  } catch (err) {
    console.log(err);
  }
}

export async function put(url, data) {
  try {
    await api.put(url, data);
  } catch (err) {
    console.log(err);
  }
}

export async function del(url) {
  try {
    await api.delete(url);
  } catch (err) {
    console.log(err);
  }
}
